import automationImage from 'images/automationCTA.jpg';
import { TRACKING } from 'common/constants/constants';
import CtaPage from 'components/CtaPage';
import { Flex } from 'components/base/layout-components';

const SECTION_TYPES = {
  FILTERS: 'FILTERS',
  ACTIONS: 'ACTIONS',
  AUTOMATIONS: 'AUTOMATIONS'
};

const TEXTS = {
  [SECTION_TYPES.FILTERS]:
    'Quickly locate Git  ' +
    ' automations by utilizing search and ' +
    ' search and sorting features.',
  [SECTION_TYPES.ACTIONS]:
    'Gain insight into the Git automations operating within' +
    ' your organization by assessing the impact on pull requests ' +
    ' (PRs) across various action types.',
  [SECTION_TYPES.AUTOMATIONS]:
    'View all Git automations currently active in your organization.' +
    ' Obtain detailed information about the pull requests (PRs) ' +
    ' processed over time and analyze the trend.'
};
const AutomationCTA = () => (
  <Flex grow='1' padding='small'>
    <CtaPage
      textsMap={TEXTS}
      page={TRACKING.PAGES.AUTOMATION}
      pageTab={TRACKING.PAGE_TABS.AUTOMATION_CTA}
      buttonLineProps={{
        leftText: 'Manage your automations!'.toUpperCase(),
        buttonText: 'SCHEDULE A WALKTHROUGH'
      }}
      backgroundImage={automationImage}
      sections={[
        {
          sectionType: SECTION_TYPES.FILTERS,
          buttonPosition: {
            left: '78%',
            top: '0.8rem'
          },
          coverProps: {
            height: '4.45rem',
            width: '100%',
            position: { top: 0 }
          },
          textPosition: { right: '-19rem', top: '-2rem' }
        },
        {
          sectionType: SECTION_TYPES.ACTIONS,
          buttonPosition: {
            bottom: '37rem',
            left: '40rem'
          },
          coverProps: {
            height: '16.45rem',
            width: '100%',
            position: { bottom: '28.6rem' }
          },
          textPosition: { right: '-19rem', top: '7rem' },
          isTextLeft: false
        },
        {
          sectionType: SECTION_TYPES.AUTOMATIONS,
          buttonPosition: {
            bottom: '10rem',
            right: '55rem'
          },
          coverProps: {
            height: '28.6rem',
            width: '100%',
            position: {
              bottom: 0,
              right: 0
            }
          },
          textPosition: { right: '-19rem', top: '30rem' }
        }
      ]}
    />
  </Flex>
);

export default AutomationCTA;
